import { formatPrice } from "../../helpers/format-price.helper";
import { formatTimeMinutesHours } from "../../helpers/format-time-minutes-hours.helpers";

export interface Variant {
  doctorId: string;
  doctorName: string;
  price: string;
  duration: number;
}

export class AppointmentTypeModel {
  private typeId: string;
  private typeName: string;
  private typeColor: string;
  private typeDuration: string;
  private typeDurationFrom?: string;
  private typeDurationTo?: string;
  private typePriceFrom?: string;
  private typePriceTo?: string;
  private nextAppointmentInterval: string;
  private typeDescription: string;
  private isAssigned: boolean;
  private typeCategory?: string;
  private variants?: Variant[];

  constructor(definition) {
    Object.keys(definition).forEach((name: string) => {
      this[name] = definition[name];
    });
  }

  public getTypeId(): string {
    return this.typeId;
  }
  public getTypeName(): string {
    return this.typeName;
  }
  public getTypeColor(): string {
    return this.typeColor;
  }
  public getTypeDuration(): string {
    return this.typeDuration;
  }
  public getFormattedTypeDuration(): string {
    return formatTimeMinutesHours(Number(this.typeDuration));
  }
  public getTypeDurationFrom(): string | undefined {
    return this.typeDurationFrom;
  }
  public getTypeDurationTo(): string | undefined {
    return this.typeDurationTo;
  }
  public getFormattedTypeDurationRange(): string {
    if (this.typeDurationFrom == null && this.typeDurationTo == null) {
      return this.getFormattedTypeDuration();
    }
    if (this.typeDurationTo == null || this.typeDurationFrom === this.typeDurationTo) {
      return formatTimeMinutesHours(Number(this.typeDurationFrom ?? this.typeDurationTo));
    }
    return `${formatTimeMinutesHours(Number(this.typeDurationFrom))} - ${formatTimeMinutesHours(Number(this.typeDurationTo))}`;
  }
  public getTypePriceFrom(): string | undefined {
    return this.typePriceFrom;
  }
  public getTypePriceTo(): string | undefined {
    return this.typePriceTo;
  }
  public getFormattedTypePrice(): string {
    return formatPrice(this.typePriceFrom);
  }
  public getFormattedTypePriceRange(): string {
    if (this.typePriceTo == null || this.typePriceFrom === this.typePriceTo) {
      return this.getFormattedTypePrice();
    }
    return `${formatPrice(this.typePriceFrom)} - ${formatPrice(this.typePriceTo)}`;
  }
  public getNextAppointmentInterval(): string {
    return this.nextAppointmentInterval;
  }
  public getTypeDescription(): string {
    return this.typeDescription;
  }
  public getIsAssigned(): boolean {
    return this.isAssigned;
  }
  public getTypeCategory(): string | undefined {
    return this.typeCategory;
  }
  public getVariants(): Variant[] {
    return this.variants || [];
  }
}
